<tec-tile [id]="OPERATION_TYPE.POL"
	[title]="operation.title"
	[formGroup]="group"
	[subtitle]="operation.description"
	[icon]="operation.icon">
	<tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.CONFIG' | translate"
		[subtitle]="'WORKFLOWS.FORM.OPERATIONS.POL_CONFIG_DESCRIPTION' | translate">
		<div class="grid grid-i2">
			<tec-card-select
				class="pol-active-gif-card-select"
				[img]="autoModeGif"
				[title]="'WORKFLOWS.FORM.OPERATIONS.POL_MODE_ACTIVE' | translate"
				[description]="'WORKFLOWS.FORM.OPERATIONS.POL_MODE_ACTIVE_DESCRIPTION' | translate"
				[selected]="mode === 'auto'"
				(selectedChange)="setMode('auto', $event)"
			></tec-card-select>
			<tec-card-select
				img="images/pol-mode-static.png"
				[title]="'WORKFLOWS.FORM.OPERATIONS.POL_MODE_STATIC' | translate"
				[description]="'WORKFLOWS.FORM.OPERATIONS.POL_MODE_STATIC_DESCRIPTION' | translate"
				[selected]="mode === 'manual'"
				(selectedChange)="setMode('manual', $event)"
			></tec-card-select>
		</div>
		@if (mode === 'auto') {
			<tec-divider></tec-divider>
			<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.DEMAND_LEVEL' | translate">
				<tec-toggle
					[options]="[
						{ id: DEMAND_LEVEL.STANDARD, label: 'WORKFLOWS.FORM.OPERATIONS.STANDARD' | translate },
						{ id: DEMAND_LEVEL.MAX_FLUID, label: 'WORKFLOWS.FORM.OPERATIONS.MAX_FLUID' | translate },
						{ id: DEMAND_LEVEL.CUSTOM, label: 'WORKFLOWS.FORM.OPERATIONS.CUSTOM' | translate }
					]"
					formControlName="type"
					[multiple]="false"
					requireSelection
				></tec-toggle>
			</tec-form-group>
			@if (demandType === DEMAND_LEVEL.CUSTOM) {
				<!-- CUSTOM -->
				<tec-tile [subtitle]="'WORKFLOWS.FORM.OPERATIONS.DEMAND_LEVEL_CUSTOM_SUBTITLE' | translate">
					<div class="grid grid-i3" formGroupName="setting">
						<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TESTS' | translate"
							[errorMsg]="reactiveFormService.hasMsgError(group.get('setting.total_test'))"
							[tooltip]="'WORKFLOWS.FORM.OPERATIONS.NUM_TESTS_TOOLTIP' | translate"
						>
							<tec-input-quantity
								[min]="1"
								[max]="3"
								[step]="1"
								formControlName="total_test"
								[hasError]="reactiveFormService.hasError(group.get('setting.total_test'))"
							></tec-input-quantity>
						</tec-form-group>
						<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED' | translate"
							[errorMsg]="reactiveFormService.hasMsgError(group.get('setting.total_tries'))"
							[tooltip]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED_TOOLTIP' | translate"
						>
							<tec-input-quantity
								[min]="1"
								[max]="3"
								[step]="1"
								formControlName="total_tries"
								[hasError]="reactiveFormService.hasError(group.get('setting.total_tries'))"
							></tec-input-quantity>
						</tec-form-group>
						<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS' | translate">
							<tec-select
								formControlName="type"
								[options]="[
									{ id: POL_TYPE.RANDOM, label: 'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS_OPTIONS.RANDOM' | translate },
									{ id: POL_TYPE.RANDOM_REPEAT, label: 'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS_OPTIONS.RANDOM_REPEAT' | translate },
									{ id: POL_TYPE.LINEAL, label: 'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS_OPTIONS.LINEAL' | translate }
								]"
								[hasError]="reactiveFormService.hasError(group.get('setting.type'))"
							></tec-select>
						</tec-info-group>
						<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD' | translate">
				<tec-toggle
					[options]="[
						{ id: CONFIDENCE_THRESHOLD.MAX, label: 'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD_OPTIONS.HIGH' | translate, tooltip: 'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD_HIGH_TOOLTIP' | translate },
						{ id: CONFIDENCE_THRESHOLD.STANDARD, label: 'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD_OPTIONS.STANDARD' | translate, tooltip: 'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD_STANDARD_TOOLTIP' | translate },
						{ id: CONFIDENCE_THRESHOLD.CUSTOM, label: 'WORKFLOWS.FORM.OPERATIONS.CUSTOM' | translate },
					]"
					formControlName="scoring"
					[multiple]="false"
					requireSelection
				></tec-toggle>
						</tec-info-group>
			@if (
				scoringThreshold === CONFIDENCE_THRESHOLD.CUSTOM
			) {
				<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.CUSTOM_CONFIDENCE_THRESHOLD' | translate">
					<tec-form-group
						[errorMsg]="
							group.get('setting.scoring_custom')?.touched &&
							group.get('setting.scoring_custom')?.invalid
								? ('WORKFLOWS.FORM.OPERATIONS.CUSTOM_CONFIDENCE_THRESHOLD_INVALID_VALUE_ERROR' | translate)
								: ''
						"
					>
						<tec-input
							type="text"
							inputmode="decimal"
							formControlName="scoring_custom"
							[hasError]="reactiveFormService.hasError(group.get('setting.scoring_custom'))"
						></tec-input>
					</tec-form-group>
				</tec-info-group>
			}
					</div>
					<tec-divider></tec-divider>
					<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS' | translate">
						<span>{{ 'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_DESCRIPTION' | translate }}</span>
					</tec-info-group>
					<div class="grid grid-e4">
						<tec-card-select
							[disabled]="true"
							[selected]="true"
							[img]="'images/centrado.png'"
							[title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.CENTER' | translate"
						></tec-card-select>
						<tec-card-select
							[selected]="hasAvailableTest(POL_TEST.SMILE)"
							[img]="'images/smile.png'"
							[title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.SMILE' | translate"
							(selectedChange)="changeAvailableTests($event, POL_TEST.SMILE)"
						></tec-card-select>
						<tec-card-select
							[selected]="hasAvailableTest(POL_TEST.TURN_RIGHT_HEAD)"
							[img]="'images/turn-right-head.png'"
							[title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.TURN_RIGHT_HEAD' | translate"
							(selectedChange)="changeAvailableTests($event, POL_TEST.TURN_RIGHT_HEAD)"
						></tec-card-select>
						<tec-card-select
							[selected]="hasAvailableTest(POL_TEST.TURN_LEFT_HEAD)"
							[img]="'images/turn-left-head.png'"
							[title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.TURN_LEFT_HEAD' | translate"
							(selectedChange)="changeAvailableTests($event, POL_TEST.TURN_LEFT_HEAD)"
						></tec-card-select>
					</div>
					@if (availableTestsUnderQuota) {
						<tec-alert [msg]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_ALERT' | translate" status="warning"></tec-alert>
					}
				</tec-tile>
			} @else {
				<!-- NO CUSTOM -->
				@for (conf of demandLevelsPol; track $index) {
					@if (demandType === conf.id) {
						<tec-tile [subtitle]="'WORKFLOWS.FORM.OPERATIONS.DEMAND_LEVEL_SUBTITLE' | translate">
							<div class="grid grid-e4">
								<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TESTS' | translate">
									<tec-badge [label]="conf.total_test" type="square"></tec-badge>
									<tec-tooltip [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TESTS_TOOLTIP' | translate" position="right">
										<tec-icon name="icon-info"></tec-icon>
									</tec-tooltip>
								</tec-info-group>
								<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED' | translate">
									<tec-badge [label]="conf.total_tries" type="square"></tec-badge>
									<tec-tooltip [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED_TOOLTIP' | translate" position="right">
										<tec-icon name="icon-info"></tec-icon>
									</tec-tooltip>
								</tec-info-group>
								<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS' | translate">
									@if (conf.type === POL_TYPE.RANDOM) {
										<span>{{ 'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS_OPTIONS.RANDOM' | translate }}</span>
									} @else if (conf.type === POL_TYPE.RANDOM_REPEAT) {
										<span>{{ 'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS_OPTIONS.RANDOM_REPEAT' | translate }}</span>
									} @else if (conf.type === POL_TYPE.LINEAL) {
										<span>{{ 'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS_OPTIONS.LINEAL' | translate }}</span>
									}
									<tec-tooltip [label]="'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS_TOOLTIP' | translate" position="right">
										<tec-icon name="icon-info"></tec-icon>
									</tec-tooltip>
								</tec-info-group>
								<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD' | translate">
									<tec-rate-status
										[value]="conf.scoring === CONFIDENCE_THRESHOLD.MAX ? 5 : 4"
										[label]="conf.scoring === CONFIDENCE_THRESHOLD.MAX ?
											('WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD_OPTIONS.HIGH' | translate) :
											'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD_OPTIONS.STANDARD' | translate"
									></tec-rate-status>
									<tec-tooltip [label]="'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD_TOOLTIP' | translate" position="right">
										<tec-icon name="icon-info"></tec-icon>
									</tec-tooltip>
								</tec-info-group>
							</div>
							<tec-divider></tec-divider>
							<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS' | translate">
								<span>{{ 'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_DESCRIPTION' | translate }}</span>
							</tec-info-group>
							<div class="grid grid-e4">
								<tec-card-select
									[disabled]="true"
									[selected]="true"
									[img]="'images/centrado.png'"
									[title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.CENTER' | translate"
								></tec-card-select>
								<tec-card-select
									[disabled]="true"
									[selected]="conf.available_tests.includes(POL_TEST.SMILE)"
									[img]="'images/smile.png'"
									[title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.SMILE' | translate"
								></tec-card-select>
								<tec-card-select
									[disabled]="true"
									[selected]="conf.available_tests.includes(POL_TEST.TURN_RIGHT_HEAD)"
									[img]="'images/turn-right-head.png'"
									[title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.TURN_RIGHT_HEAD' | translate"
								></tec-card-select>
								<tec-card-select
									[disabled]="true"
									[selected]="conf.available_tests.includes(POL_TEST.TURN_LEFT_HEAD)"
									[img]="'images/turn-left-head.png'"
									[title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.TURN_LEFT_HEAD' | translate"
								></tec-card-select>
							</div>
						</tec-tile>
					}
				}
			}
		}
	</tec-tile>

	@if (mode) {
		<!-- ANTIFRAUDE -->
		<tec-item [title]="'WORKFLOWS.FORM.GENERAL.ANTIFRAUDE_GENERAL' | translate" collapse [expanded]="id">
			<div class="item-group" formGroupName="fraud_scoring">
				<tec-item [classes]="['item--outline']"
					[title]="'WORKFLOWS.FORM.OPERATIONS.FACIAL_RECOGNITION' | translate"
					[tagImage]="{icon: 'icon-shield'}"
					[clickeable]="false">
					<tec-list-detail>
						<span>{{ 'WORKFLOWS.FORM.OPERATIONS.FACIAL_RECOGNITION_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
					<tec-switch formControlName="facial_recognition" size="sm"></tec-switch>
				</tec-item>
				<tec-divider></tec-divider>
				<tec-item [classes]="['item--outline']"
					[title]="'WORKFLOWS.FORM.OPERATIONS.FACE_MATCH' | translate"
					[tagImage]="{icon: 'icon-user'}"
					[clickeable]="false">
					<tec-list-detail>
						<span>{{ 'WORKFLOWS.FORM.OPERATIONS.FACE_MATCH_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
					<tec-switch formControlName="face_match" size="sm"></tec-switch>
				</tec-item>
				<tec-divider></tec-divider>
				<tec-item [classes]="['item--outline']"
					[title]="'WORKFLOWS.FORM.OPERATIONS.PERCENTAGE_SIMILARITY' | translate"
					[tagImage]="{icon: 'icon-users'}"
					[clickeable]="false">
					<tec-list-detail>
						<span>{{ 'WORKFLOWS.FORM.OPERATIONS.PERCENTAGE_SIMILARITY_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
					<tec-input
						type="number"
						formControlName="percentage_similarity"
						[hasError]="reactiveFormService.hasError(group.get('fraud_scoring.percentage_similarity'))"
					></tec-input>
				</tec-item>
				<tec-divider></tec-divider>
				<tec-item [classes]="['item--outline']"
					[title]="'WORKFLOWS.FORM.OPERATIONS.ANTISPOOFING' | translate"
					[tagImage]="{icon: 'icon-shield'}"
					[clickeable]="false">
					<tec-list-detail>
						<span>{{ 'WORKFLOWS.FORM.OPERATIONS.ANTISPOOFING_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
					<tec-switch formControlName="anti_spoofing" size="sm"></tec-switch>
				</tec-item>
			</div>
		</tec-item>

		<!-- CONFIGURACION AVANZADA -->
		<app-workflow-form-advanced-collapse [expanded]="id">
			<div class="item-group">
				<tec-item [classes]="['item--outline']"
					[title]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL' | translate"
					[tagImage]="{icon: 'icon-AI'}">
					<tec-list-detail>
						<span>{{ 'WORKFLOWS.FORM.OPERATIONS.TUTORIAL_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
					<tec-switch formControlName="tutorial" size="sm"></tec-switch>
				</tec-item>
			</div>
		</app-workflow-form-advanced-collapse>
	}
</tec-tile>
